// define templates for the Symmetry-Clean Canvas-7.0.0 theme
window._usf_chosen_aspect_ratio = 0;
var _usfImageWidths;
var _usfImageSize = '';
window._usf_custom_aspect_ratio = 1;
usf.event.add(['sr_dataReceived','is_dataReceived'], function(t, data){
    if(data.currency.format=='Dhs. {0}'){ 
        data.currency.format='{0} AED'
    } 
    if (data && data.items && data.items.length) {	
        data.items.forEach(p => {	
            if (p.selectedVariantId) p.selectedVariantId = null	
        })	
    }
});
var _usfFilterBodyTemplate = /*inc_begin_filter-body*/
`<!-- Range filter -->
<div v-if="isRange" class="usf-facet-values usf-facet-range">
    <!-- Range inputs -->
    <div class="usf-slider-inputs usf-clear">
        <span class="usf-slider-input__from">
            <span class="usf-slider-input__prefix" v-html="facet.sliderPrefix" v-if="facet.showSliderInputPrefixSuffix"></span>
            <input :readonly="!hasRangeInputs" :value="rangeConverter(range[0]).toFixed(rangeDecimals)" @change="e => onRangeInput(e, range[0], 0)">
            <span class="usf-slider-input__suffix" v-html="facet.sliderSuffix" v-if="facet.showSliderInputPrefixSuffix"></span>
        </span>
        <span class="usf-slider-div">-</span>
        <span class="usf-slider-input__to">
            <span class="usf-slider-input__prefix" v-html="facet.sliderPrefix" v-if="facet.showSliderInputPrefixSuffix"></span>
            <input :readonly="!hasRangeInputs" :value="rangeConverter(range[1]).toFixed(rangeDecimals)" @change="e => onRangeInput(e, range[1], 1)">
            <span class="usf-slider-input__suffix" v-html="facet.sliderSuffix" v-if="facet.showSliderInputPrefixSuffix"></span>
        </span>
    </div>
	<!-- See API reference of this component at https://docs.sobooster.com/search/storefront-js-api/slider-component -->
    <usf-slider :color="facet.sliderColor" :symbols="facet.sliderValueSymbols" :prefix="facet.sliderPrefix" :suffix="facet.sliderSuffix" :min="facet.min" :max="facet.max" :pips="facet.range[0]" :step="facet.range[1]" :decimals="rangeDecimals" :value="range" :converter="rangeConverter" @input="onRangeSliderInput" @change="onRangeSliderChange"></usf-slider>
</div>
<!-- List + Swatch filter -->
<div v-else ref="values" :class="'usf-facet-values usf-scrollbar usf-facet-values--' + facet.display + (facet.navigationCollections ? ' usf-navigation' : '') + (facet.valuesTransformation ? (' usf-' + facet.valuesTransformation.toLowerCase()) : '') + (facet.circleSwatch ? ' usf-facet-values--circle' : '')" :style="!usf.isMobileFilter && facet.maxHeight ? { maxHeight: facet.maxHeight } : null">
    <!-- Filter options -->                
    <usf-filter-option v-for="o in visibleOptions" :facet="facet" :option="o" :key="o.id ? o.id : o.label+'_'+o.min+'_'+o.max"></usf-filter-option>
</div>

<!-- More -->
<div v-if="isMoreVisible" class="usf-more" @click="onShowMore" v-html="loc.more"></div>`
/*inc_end_filter-body*/;

var _usfSearchResultsSkeletonItemTpl = /*inc_begin_search-skeleton-item*/
`<div v-if="view === 'grid'" class="usf-sr-product usf-skeleton">
    <div class="usf-img"></div>
    <div class="usf-meta"></div>
</div>
<div class="usf-sr-product usf-skeleton" v-else>
    <!-- Image column -->
    <div class="usf-img-column">
        <div class="usf-img"></div>
    </div>

    <!-- Info column -->
    <div class="usf-info-column">
        <div class="usf-title"></div>
        <div class="usf-vendor"></div>
        <div class="usf-price-wrapper"></div>
    </div>
</div>`
/*inc_end_search-skeleton-item*/;

var _usfSearchResultsSummaryTpl = /*inc_begin_search-summary*/
`<span class="usf-sr-summary" v-html="loader === true ? '&nbsp;' : usf.utils.format(term ? loc.productSearchResultWithTermSummary : loc.productSearchResultSummary, result.total, usf.utils.encodeHtml(term))"></span>`
/*inc_end_search-summary*/;

var _usfSearchResultsViewsTpl = /*inc_begin_search-views*/
`<div class="usf-views">
    <button class="usf-view usf-btn usf-icon usf-icon-grid" aria-label="Grid view" :class="{'usf-active': view === 'grid'}" @click.prevent.stop="onGridViewClick"></button>
    <button class="usf-view usf-btn usf-icon usf-icon-list" aria-label="List view" :class="{'usf-active': view === 'list'}" @click.prevent.stop="onListViewClick"></button>
</div>`
/*inc_end_search-views*/;

var _usfSearchResultsSortByTpl = /*inc_begin_search-sortby*/
`<usf-dropdown :placeholder="loc.sort" :value="sortBy" :options="sortByOptions" @input="onSortByChanged"></usf-dropdown>`
/*inc_end_search-sortby*/;

usf.templates = {
    // application
    app: 
    `<div id="usf_container" class="usf-zone usf-clear" :class="{'usf-filters-horz': usf.settings.filters.horz}">
        <template v-if="hasFilters">
            <symmetry-filter class="usf-sr-filters"></symmetry-filter>
        </template>
        <usf-sr></usf-sr>
    </div>`
    ,

    // search results
    searchResults: `
<div class="usf-sr-container usf-general" :class="{'usf-no-facets': noFacets, 'usf-empty': !loader && !hasResults, 'usf-nosearch': !showSearchBox}">
    <!-- Search form -->
    <form v-if="showSearchBox" action="/search" method="get" role="search" class="usf-sr-inputbox">
        <button type="submit" class="usf-icon usf-icon-search usf-btn"></button>
        <input name="q" autocomplete="off" ref="searchInput" v-model="termModel">
        <button v-if="termModel" class="usf-remove usf-btn" @click.prevent.stop="clearSearch"></button>
    </form>

    <div class="usf-sr-config" v-if="usf.isMobile">
        <div class="usf-sr-config__mobile-filters-wrapper">
            <div class="usf-filters" :class="{'usf-has-filters': !!facetFilters}" @click="onMobileToggle">
                <button class="usf-btn" v-html="loc.filters"></button>
            </div>
            ` + _usfSearchResultsSortByTpl + `
        </div>
        
        ` + _usfSearchResultsSummaryTpl + _usfSearchResultsViewsTpl + `
    </div>
    <div class="usf-sr-config" v-else>
        ` + _usfSearchResultsViewsTpl + _usfSearchResultsSummaryTpl + _usfSearchResultsSortByTpl + `
    </div>

    <usf-sr-banner v-if="result && result.extra && result.extra.banner && !result.extra.banner.isBottom" :banner="result.extra.banner"></usf-sr-banner>

    <!-- Load previous -->
    <div id="usf-sr-top-loader" :class="{'usf-with-loader':loader === 'prev'}" v-if="(loader === 'prev' || itemsOffset) && loader !== true && hasResults && usf.settings.search.more !== 'page'"></div>
    <div :class=" (view === 'grid' ? _usfGridWrapClass : '') + \' usf-results usf-clear usf-\' + view">
        <template v-if="0 || loader===true">` + _usfSearchResultsSkeletonItemTpl + _usfSearchResultsSkeletonItemTpl + _usfSearchResultsSkeletonItemTpl + _usfSearchResultsSkeletonItemTpl +
        `</template>
        <template v-else>
            <template v-if="hasResults">
                <template v-if="view === 'grid'">
                    <template v-for="p in result.items"><usf-new-griditem :product="p" :result="result" :key="p.id"></usf-new-griditem></template>
                </template>
                <template v-else>
                    <template v-for="p in result.items"><usf-sr-listitem :product="p" :result="result" :key="p.id"></usf-sr-listitem></template>
                </template>
            </template>
        
        </template>
    </div> 

    <!-- Empty result -->
                <div v-if="!(loader === true || hasResults)" class="usf-sr-empty">
                    <div class="usf-icon"></div>
                    <span v-html="term ? usf.utils.format(loc.productSearchNoResults, usf.utils.encodeHtml(term)) : loc.productSearchNoResultsEmptyTerm"></span>
                </div>

    <usf-sr-banner v-if="result && result.extra && result.extra.banner && result.extra.banner.isBottom" :banner="result.extra.banner"></usf-sr-banner>

    <!-- Paging & load more -->
    <div class="usf-sr-paging" v-if="loader !== true">
        <div class="usf-sr-more" v-if="hasResults && usf.settings.search.more === 'more'">
            <div class="usf-title" v-html="usf.utils.format(loc.youHaveViewed, itemsLoaded, result.total)"></div>
            <div class="usf-progress">
                <div :style="{width: (itemsLoaded * 100 / result.total) + '%'}"></div>
            </div>
            <button v-if="itemsLoaded < result.total" class="usf-load-more" :class="{'usf-with-loader': loader === 'more'}" @click="onLoadMore"><span v-html="loc.loadMore"></span></button>
        </div>
        <usf-sr-pages v-else-if="hasResults && usf.settings.search.more === 'page'" :page="page" :pages-total="pagesTotal" :pages-to-display="4" :side-pages-to-display="1"></usf-sr-pages>
        <div class="usf-sr-loader usf-with-loader" v-else-if="loader === 'more'"></div>
    </div>
</div>
`,
    // Grid view item
    searchResultsGridViewItem: `
    <product-block class="product-block" :data-product-id="product.id" :product-selector="product.id" :data-usf-pid="product.id">
    <div class="block-inner" data-cc-animate>
        <div class="block-inner-inner">
            <!-- Wishlist -->
            <usf-plugin name="searchResultsProductWishList" :data="pluginData"></usf-plugin>
            <!-- Labels -->
            <usf-plugin name="searchResultsProductLabel" :data="pluginData"></usf-plugin>
            <div v-if="product.images.length" class="image-cont" :class="{'image-cont--with-secondary-image': _usfGlobalSettings.prod_thumb_hover_image && hoverImage,'image-cont--same-aspect-ratio': _usfGlobalSettings.prod_thumb_hover_image && hoverImage && _usfGetImageRatio(selectedImage) == _usfGetImageRatio(hoverImage)}">
                <a class="product-link" :href="productUrl" @click="onItemClick" @mouseover="onItemHover" @mouseleave="onItemLeave" aria-hidden="true" tabindex="-1" :class="{'quickbuy-toggle': _usfGlobalSettings.quickbuy_style == 'whole'}">
                    <div class="image-label-wrap">
                        <div >
                            <template v-if="_usfGlobalSettings.prod_thumb_hover_image && hoverImage">
                                <div class="product-block__image product-block__image--primary product-block__image--active" :data-media-id="selectedImage.id">
                                    <div class="img-ar img-ar--contain" :style="'--aspect-ratio:' + _usf_custom_aspect_ratio">
                                        <usf-img :image="selectedImage" :imageUrl="selectedImageUrl" ></usf-img>
                                    </div>
                                </div>
                                <div v-for="(img,index) in product.images" v-if="img.url != selectedImage.url" class="product-block__image product-block__image--secondary product-block__image--inactivated" :class="{'product-block__image--show-on-hover': img.url === hoverImage.url}" :data-media-id="img.id" :data-image-index="index">
                                    <div class="img-ar img-ar--contain" :style="'--aspect-ratio:' + _usf_custom_aspect_ratio">
                                        <usf-img :image="img" ></usf-img>
                                    </div>
                                </div>
                            </template>
                            <div v-else class="product-block__image product-block__image--primary product-block__image--active" :data-media-id="selectedImage.id">
                                <div class="img-ar img-ar--contain" :style="'--aspect-ratio:' + _usf_custom_aspect_ratio">
                                    <usf-img :image="selectedImage" :imageUrl="selectedImageUrl" ></usf-img>
                                </div>
                            </div>
                        </div>
                        <div v-if="_usfGlobalSettings.prod_thumb_hover_image && hoverImage" class="product-block__image-dots" aria-hidden="true">
                            <div class="product-block__image-dot product-block__image-dot--active"></div>
                            <div class="product-block__image-dot"></div>
                            <div v-if="product.images.length > 2" class="product-block__image-dot product-block__image-dot--more"></div>
                        </div>
  
                        <!--labels-->
                        <div class="product-label-container">
                            <span v-if="metaLable != ''" class="product-label product-label--meta">
                                <span v-html="metaLable"></span>
                            </span>
                            <span v-if="showNew" class="product-label product-label--new-in">
                                <span v-html="_usfNewTxt"></span>
                            </span>
                            <span v-if="labelCount < 2 && saleLabel" class="product-label product-label--sale">
                                <span v-html="saleLabel"></span>
                            </span>
                            <span v-if="labelCount < 2 && _usfGlobalSettings.prod_stock_warn_show && _usfGlobalSettings.prod_stock_warn_limit_int == 0 && product.variants.length == 1 && selectedVariantForPrice.available > 0" class="product-label product-label--stock">
                                <span v-html="_usfOnlyLeft.replace('{{ quantity }}',selectedVariantForPrice.available)"></span>
                            </span>
                            <span v-else-if="labelCount < 2 && _usfGlobalSettings.prod_stock_warn_show && product.variants.length == 1 && selectedVariantForPrice.available > 0 && selectedVariantForPrice.available <= _usfGlobalSettings.prod_stock_warn_limit_int" class="product-label product-label--stock">
                                <span v-html="_usfOnlyLeft.replace('{{ quantity }}',selectedVariantForPrice.available)"></span>
                            </span>
                        </div>
                        <!--end labels-->
                    </div>
                </a>
                <template v-if="_usfGlobalSettings.prod_thumb_hover_image && hoverImage">
                    <a class="image-page-button image-page-button--previous has-ltr-icon" href="#" :aria-label="_usfPrevTxt" tabindex="-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-left" aria-hidden="true" focusable="false" role="presentation">
                            <path d="m15 18-6-6 6-6" />
                        </svg>
                    </a>
                    <a class="image-page-button image-page-button--next has-ltr-icon" href="#" :aria-label="_usfNextTxt" tabindex="-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-right" aria-hidden="true" focusable="false" role="presentation">
                            <path d="m9 18 6-6-6-6" />
                        </svg>
                    </a>
                </template>
  
                <a v-if="_usfGlobalSettings.quickbuy_style == 'button'" class="btn btn--secondary quickbuy-toggle" :href="productUrl" v-html="loc.quickView"></a>
  
            </div>
  
            <div v-else class="image-cont">
                <div class="placeholder-image" v-html="_usfNoImageSvg"></div>
                <a v-if="_usfGlobalSettings.quickbuy_style == 'button'" class="btn btn--secondary quickbuy-toggle" :href="productUrl" v-html="loc.quickView"></a>
            </div>
  
            <div :class="'product-block__detail align-ltr-' + _usfGlobalSettings.prod_thumb_text_align">
                <div class="inner">
                    <div class="innerer">
                        <a class="product-link" :href="productUrl" :class="{'quickbuy-toggle': _usfGlobalSettings.quickbuy_style == 'whole'}">
                            <!--vendor-->
                            <div v-if="_usfShowVendor && usf.settings.search.showVendor" class="vendor" v-html="product.vendor"></div>
  
                            <div class="product-block__title" v-html="product.title"></div>
                            <!--subtitle-->
                            <div v-if="_usfGlobalSettings.prod_thumb_show_subtitle && subtitle != ''" class="product-block__subtitle" v-html="subtitle"></div>
                            <!--price-->
                            <div class="product-price product-price--block">
                                <div class="price" :class="{'price--on-sale': hasDiscount, 'price--sold-out': isSoldOut}">
                                    <div class="price__default">
                                        <span v-if="priceVaries && !product.selectedVariantId" class="price__from" v-html="loc.from"></span>
                                        <span class="price__current" v-html="priceVaries && !product.selectedVariantId ? displayMinDiscountedPrice : displayDiscountedPrice"></span>
                                        <span v-if="hasDiscount" class="price__was" v-html="displayPrice"></span>
                                    </div>
                                    <span v-if="_usfGlobalSettings.prod_sold_out_show && usf.settings.search.showSoldOut && isSoldOut" class="price-label price-label--sold-out" v-html="loc.soldOut"></span>
                                    <span v-else-if="_usfGlobalSettings.prod_sale_show && usf.settings.search.showSale && hasDiscount" class="price-label price-label--sale" v-html="loc.sale"></span>
                                </div>
                            </div>
                        </a>
                        <template v-if="_usfGlobalSettings.swatch_enabled && _usfGlobalSettings.prod_thumb_show_options">
                            <usf-swatches v-for="(option,optIndex) in product.options" v-if="_usf_options_to_show.includes(option.name)" :option="option" :product="product" :optionIndex="optIndex"></usf-swatches>
                        </template>
                        
                        <!--swatch-->
                        
                        <!-- Swatch-->
                        <usf-plugin name="searchResultsProductSwatch" :data="pluginData"></usf-plugin>
                        <!-- Product review -->
                        <usf-plugin name="searchResultsProductReview" :data="pluginData"></usf-plugin>
                    </div>
                </div>
            </div>
        </div>
    </div> 
  
    <!--quick buy-->
    <div v-if="_usfGlobalSettings.quickbuy_style != 'off'" :class="'quickbuy-container use-color-scheme use-color-scheme--' + _usfGlobalSettings.quickbuy_color_scheme">
        <a href="#" class="close-detail" aria-label="close" tabindex="-1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-x" aria-hidden="true" focusable="false" role="presentation">
                <path d="M18 6 6 18M6 6l12 12" />
            </svg>
        </a>
        <div class="inner"></div>
    </div> 
    <!--quick buy--> 
  </product-block>
`,
    // Search result pages
    searchResultsPages: `
<center>
    <div class="container pagination-row">
        <div class="pagination">
            <template v-for="e in elements">
                <template v-if="e.type === 'prev'">
                    <a  href="javascript:void(0)" :title="loc.prevPage" @click="onPrev" class="pagination__prev pagination__link text-current underline underline--on-hover" v-html="'« ' + loc.prevPage + '  '"></a>
                    <span class="pagination__sep">·</span>
                </template>
                <span v-else-if="e.type === 'dots'" class="usf-sr-pages__dots"><span>...</span></span> 
                <span v-else-if="e.type === 'page' && e.current" class="pagination__number underline underline--not-link"><span>{{e.page}}</span></span>
                <span v-else-if="e.type === 'page' && !e.current" class="pagination__number"><a href="javascript:void(0)" @click="ev=>onPage(e.page,ev)" :title="usf.utils.format(loc.gotoPage,e.page)" class="pagination__link text-current underline underline--on-hover">{{e.page}}</a></span>
                <template v-else-if="e.type === 'next'">
                    <span class="pagination__sep">·</span>
                    <a  href="javascript:void(0)" :title="loc.nextPage" @click="onNext" class="pagination__next pagination__link text-current underline underline--on-hover" v-html="'  ' +loc.nextPage + ' »'">→</a>
                </template>
            </template>
        </div>
    </div>
</center>
`,
    // List view item
    searchResultsListViewItem: /*inc_begin_search-list-item*/
`<a class="usf-sr-product" @click="onItemClick" @mouseover="onItemHover" @mouseleave="onItemLeave" :href="productUrl" :data-usf-pid="product.id">
    <!-- Image column -->
    <div class="usf-img-column">
        <!-- product image -->
        <div class="usf-img-wrapper usf-sr-product__image-container" :class="{'usf-has-second-img': hoverImage}">
            <div class="usf-main-img lazyload" :data-bgset="_usfGetScaledImageUrl(scaledSelectedImageUrl)" :style="{'background-image': 'url(' + getSelectedImageUrl('600') + ')'}"></div>
            <span class="usf-img-loader"></span>
            <template v-if="hoverImage">
                <div class="usf-second-img lazyload" :data-bgset="_usfGetScaledImageUrl(scaledHoverImageUrl)" :style="{'background-image': 'url(' + getHoverImageUrl('600') + ')'}"></div>
                <span class="usf-img-loader"></span>
            </template>
            <!-- product image extra -->
            <usf-plugin name="searchResultsProductPreview" :data="pluginData"></usf-plugin>
            <usf-plugin name="searchResultsProductCart" :data="pluginData"></usf-plugin>
            
            <div v-if="isSoldOut && usf.settings.search.showSoldOut" class="usf-badge"><span v-html="loc.soldOut"></span></div>
            <div v-else-if="hasDiscount && usf.settings.search.showSale" class="usf-badge usf-sale-badge"><span v-html="loc.sale"></span></div>
        </div>
    </div>

    <!-- Info column -->
    <div class="usf-info-column">
        <div class="usf-title" v-html="product.title"></div>
        <div class="usf-vendor" v-if="usf.settings.search.showVendor" v-html="product.vendor"></div>

        <!-- price -->
        <usf-plugin name="searchResultsProductPrice" :data="pluginData"></usf-plugin>
        <div class="usf-price-wrapper" :class="{'usf-price--sold-out': isSoldOut}" v-if="!usf.plugins.lastRenderResult" :data-variant-id="product.selectedVariantId">
            <span class="usf-price" :class="{'usf-has-discount': hasDiscount}" v-html="displayPrice"></span>
            <span class="usf-discount" v-if="hasDiscount" v-html="displayDiscountedPrice"></span>
            <span v-if="hasDiscount" class="usf-price-savings" v-html="loc.save + ' ' + salePercent + '%'"></span>
        </div>
        <div class="usf-description"></div>
    </div>
</a>`
/*inc_end_search-list-item*/,
    // AddToCart Plugin	
    addToCartPlugin: /*inc_begin_addtocart-plugin*/
`<form class="usf-add-to-cart" method="POST" enctype="multipart/form-data" :action="usf.platform.addToCartUrl">
    <input type="hidden" name="form_type" value="product">
    <input type="hidden" name="utf8" value="✓">
    <input type="hidden" name="quantity" value="1">
    <input type="hidden" name="id" :value="variant.id">
    <usf-choose-options v-if="args.product.variants.length > 1" :loc="usf.settings.translation" :args="args"></usf-choose-options>
    <button v-else-if="!usf.utils.isVariantSoldOut(variant)" type="submit" name="add" class="usf-add-to-cart-btn" :data-product-id="args.product.id" @click.prevent.stop="_usfAddToCart">
        <span class="usf-icon usf-icon-cart"></span>
        <span class="usf-label" v-html="loc.addToCart"></span>
    </button>
</form>`
/*inc_end_addtocart-plugin*/,

    // Preview Plugin
    previewPlugin: /*inc_begin_preview-plugin*/
`<div class="usf-sr-preview" :class="['usf-sr-' + settings.iconPosition]" @click.prevent.stop="onShowModal">
    <span class="usf-icon usf-icon-eye"></span>
</div>`
/*inc_end_preview-plugin*/,

    previewPluginModal: /*inc_begin_preview-modal*/
`<div><div class="usf-backdrop"></div><div class="usf-preview__wrapper usf-zone"><div class="usf-preview__container">
    <div class="usf-preview">
        <!-- Close button -->
        <div class="usf-remove" @click="onClose"></div>

        <!-- Body content -->
        <div class="usf-preview__body">
            <!-- left - images of product -->
            <div class="usf-preview__content-left">
                <!-- Big image -->
                <div class="usf-preview__image-slider">
                    <div type="button" title="Prev" class="usf-preview__image-slider__btn usf-prev usf-icon usf-icon-up" @click="onPrevImage(0)" v-if="showBigImageNav"></div>

                    <div class="usf-preview__image-slider__track">
                        <div v-for="i in images" class="usf-preview__image-wrapper" :class="{'usf-active': image === i}"">
                            <div v-if="image === i" class="usf-preview__image lazyload" :data-bgset="usf.platform.getImageUrl(i.url,1024)" :style="'background-image:url('+usf.platform.getImageUrl(i.url, 1024)+')'"></div>
                            <span class="usf-img-loader"></span>
                        </div>
                    </div>

                    <div type="button" title="Next" class="usf-preview__image-slider__btn usf-next usf-icon usf-icon-up" @click="onNextImage(0)" v-if="showBigImageNav"></div>

                    <ul class="usf-preview__image-slider__dots" v-if="showImageIndices && false">
                        <li :class="{'active':i===image}" v-for="(i,index) in images"  @click="onThumbClick(i)"><button type="button">{{index+1}}</button></li>
                    </ul>
                </div>

                <!-- Thumbnails -->
                <div class="usf-preview__thumbs" v-if="showThumbs">
                    <div class="usf-preview__thumbs-inner">
                        <span v-for="i in images" class="usf-preview__thumb" :class="{'usf-active': image === i}" @click="onThumbClick(i)"></span>
                    </div>
                </div>

                <!-- Badges -->
                <div class="usf-preview__badge usf-preview__badge-sale" v-if="hasDiscount" v-html="loc.sale"></div>
            </div>

            <!-- right - info of the product -->
            <div class="usf-preview__content-right usf-scrollbar">
                <div class="usf-preview__content-summary">
                    <!-- Product title -->
                    <h1 class="usf-preview__title"><a :href="productUrl" v-html="product.title"></a></h1>

                    <!-- Vendor -->
                    <div class="usf-preview__vendor" v-html="product.vendor" v-if="usf.settings.search.showVendor"></div>

                    <!--Prices -->
                    <div class="usf-preview__price-wrapper" :class="{'price--sold-out': isSoldOut}">
                        <span class="usf-price" :class="{'usf-has-discount': hasDiscount}" v-html="usf.utils.getDisplayPrice(selectedVariant.compareAtPrice || selectedVariant.price)"></span>
                        <span v-if="hasDiscount" class="usf-discount" v-html="usf.utils.getDisplayPrice(selectedVariant.price)"></span>

                        <div v-if="false" class="price__badges price__badges--listing">
                            <span class="price__badge price__badge--sale" aria-hidden="true" v-if="hasDiscount && usf.settings.search.showSale">
                                <span v-html="loc.sale"></span>
                            </span>
                            <span class="price__badge price__badge--sold-out" v-if="isSoldOut && usf.settings.search.showSoldOut">
                                <span v-html="loc.soldOut"></span>
                            </span>
                        </div>
                    </div>

                    <!-- Description -->
                    <p class="usf-preview__description" :class="{'usf-with-loader':description===undefined}" v-html="description"></p>

                    <!-- Add to cart form -->
                    <form method="post" enctype="multipart/form-data" :action="usf.platform.addToCartUrl" @submit="_usfAddToCart">
                        <!-- variant ID -->
                        <input type="hidden" name="id" :value="selectedVariant.id" />

                        <!-- Options -->
                        <template v-for="(o,index) in product.options">
                            <usf-preview-modal-option :option="o" :index="index"></usf-preview-modal-option>
                        </template>

                        <!-- add to card button -->
                        <div class="usf-preview__field">                            
                            <div class="usf-flex usf-preview__add-to-cart">
                                <usf-num-input v-model="quantity" name="quantity" :disabled="!hasAvailableVariant" :min="1" :max="available" />
                                <button :title="!hasAvailableVariant ? loc.selectedVariantNotAvailable : ''" :disabled="!hasAvailableVariant" type="submit" name="add" class="usf-add-to-cart-btn" :class="{ 'usf-disabled': !hasAvailableVariant}">
                                    <span class="usf-label" v-html="loc.addToCart"></span>
                                </button>
                            </div>
                        </div>
                    </form>

                    <!-- See details link -->
                    <a class="usf-preview__link" :href="productUrl" v-html="loc.seeFullDetails"></a>
                </div>
            </div>
        </div>
    </div>
</div></div></div>`
/*inc_end_preview-modal*/,

    searchResultsBanner: /*inc_begin_search-banner*/        
`<div class="usf-sr-banner">
    <a :href="banner.url || 'javascript:void(0)'" :alt="banner.description">
        <img :src="banner.mediaUrl" style="max-width:100%">
    </a>
</div>
`
/*inc_end_search-banner*/,

    ////////////////////////
    // Filter templates
    // facet filters breadcrumb
    filtersBreadcrumb: /*inc_begin_filters-breadcrumb*/
`<div v-if="usf.settings.filterNavigation.showFilterArea && root.facetFilters && root.facets && facetFilterIds.length" class="usf-refineby">
    <!-- Breadcrumb Header -->
    <div class="usf-title usf-clear">
        <span class="usf-pull-left usf-icon usf-icon-equalizer"></span>
        <span class="usf-label" v-html="loc.filters"></span>

        <!-- Clear all -->
        <button class="usf-clear-all usf-btn" v-html="loc.clearAll" @click.prevent.stop="root.removeAllFacetFilters" :aria-label="loc.clearAllFilters"></button>
    </div>

    <!-- Breadcrumb Values -->
    <div class="usf-refineby__body">
        <template v-for="facetId in facetFilterIds" v-if="(facet = root.facets.find(fc => fc.id === facetId)) && (f = root.facetFilters[facetId])">
            <template v-for="queryValStr in f[1]">
                <div class="usf-refineby__item usf-pointer usf-clear" @click.prevent.stop="root.removeFacetFilter(facetId, queryValStr)">
                    <button class="usf-btn"><span class="usf-filter-label" v-html="facet.title + ': '"></span><b v-html="root.formatBreadcrumbLabel(facet, f[0], usf.utils.encodeHtml(queryValStr))"></b></button><span class="usf-remove"></span>
                </div>
            </template>
        </template>
    </div>
 </div>`
 /*inc_end_filters-breadcrumb*/,

    // facet filters    
    filters: /*inc_begin_filters*/
// Vert & Horz modes have different render order
`<div class="usf-facets usf-no-select usf-zone" :class="{'usf-facets--mobile':usf.isMobileFilter}">
<!-- Mobile view -->
<template v-if="usf.isMobile">
    <div class="usf-close" @click="onMobileBack(1)"></div>
    <div class="usf-facets-wrapper">
        <!-- Header. shows 'Filters', facet name, etc. -->
        <div class="usf-header">
            <!-- Single facet mode -->
            <template v-if="isSingleFacetMode">
                <div class="usf-title" @click="onMobileBack(0)" v-html="facets[0].title"></div>
                <div v-if="facetFilters" class="usf-clear" @click="removeAllFacetFilters" v-html="loc.clear"></div>
            </template>

            <!-- When a filter is selected -->
            <template v-else-if="mobileSelectedFacet">
                <div class="usf-title usf-back" @click="onMobileBack(0)" v-html="mobileSelectedFacet.title"></div>
                <div v-if="facetFilters && facetFilters[mobileSelectedFacet.id]" class="usf-clear" @click="removeFacetFilter(mobileSelectedFacet.id)" v-html="loc.clear"></div>
                <div v-else-if="mobileSelectedFacet.multiple" class="usf-all" @click="selectFacetFilter(mobileSelectedFacet)" v-html="loc.all"></div>
            </template>

            <!-- When no filter is selected -->
            <template v-else>
                <div class="usf-title" @click="onMobileBack(0)" v-html="loc.filters"></div>
                <div v-if="facetFilters" class="usf-clear" @click="removeAllFacetFilters" v-html="loc.clearAll"></div>
            </template>
        </div>

        <div class="usf-body">
            <!-- Desktop-like filter in mobile -->
            <template v-if="usf.settings.filters.desktopLikeMobile">
                <usf-filter-breadcrumb></usf-filter-breadcrumb>
                
                <!-- Facets body -->
                <div class="usf-facets__body">
                    <usf-filter :facet="f" :key="f.id" v-for="f in facets"></usf-filter>
                </div>
            </template>
            
            <!-- Mobile filter -->
            <template v-else>
                <!-- List all filter options, in single facet mode -->
                <usf-filter v-if="isSingleFacetMode" :facet="facets[0]"></usf-filter>

                <!-- List all filter options, when a filter is selected -->
                <usf-filter v-else-if="mobileSelectedFacet" :facet="mobileSelectedFacet"></usf-filter>

                <!-- List all when there are more than one facet -->
                <template v-else v-for="f in facets">
                    <template v-if="canShowFilter(f)">
                        <div :key="f.id" class="usf-facet-value" @click="onMobileSelectFacet(f)">
                            <span class="usf-title" v-html="f.title"></span>
                            <div v-if="(selectedFilterOptionValues = facetFilters && (ff = facetFilters[f.id]) ? ff[1] : null)" class="usf-dimmed">
                                <span v-for="cf in selectedFilterOptionValues" v-html="formatBreadcrumbLabel(f, f.facetName, cf)"></span>
                            </div>
                        </div>
                    </template>
                </template>
            </template>
        </div>

        <!-- View items -->
        <div class="usf-footer">
            <div @click="onMobileBack(1)" v-html="loc.viewItems"></div>
        </div>
    </div>
</template>

<!-- Desktop view -->
<template v-else>
    <usf-filter-breadcrumb></usf-filter-breadcrumb>
    <!-- Filters Loader -->
    <div v-if="!facets" class="usf-facets__first-loader">
        <template v-for="i in 3">
            <div class="usf-facet"><div class="usf-title usf-no-select"><span class="usf-label"></span></div>
                <div v-if="!usf.settings.filters.horz" class="usf-container"><div class="usf-facet-values usf-facet-values--List"><div class="usf-relative usf-facet-value usf-facet-value-single"><span class="usf-label"></span><span class="usf-value"></span></div><div class="usf-relative usf-facet-value usf-facet-value-single"><span class="usf-label"></span><span class="usf-value"></span></div></div></div>
            </div>
        </template>
    </div>
    <!-- Facets body -->
    <div v-else class="usf-facets__body">
        <usf-filter :facet="f" :key="f.id" v-for="f in facets"></usf-filter>
    </div>
</template>
</div>`
/*inc_end_filters*/,

    // facet filter item
    filter: /*inc_begin_filter*/
`<div v-if="canShow" class="usf-facet" :class="{'usf-collapsed': collapsed && !usf.isMobileFilter, 'usf-has-filter': isInBreadcrumb}">
    <!-- Mobile filter -->
    <div v-if="usf.isMobileFilter" class="usf-container">
        <!-- Search box -->
        <input v-if="hasSearchBox" class="usf-search-box" :aria-label="loc.filterOptions" :placeholder="loc.filterOptions" :value="term" @input="v => term = v.target.value">

        <!-- Values -->
        ` + _usfFilterBodyTemplate +
    `</div>

    <!-- Desktop filter -->
    <template v-else>
        <!-- Filter title -->
        <div class="usf-clear">
            <div class="usf-title usf-no-select" @click.prevent.stop="onExpandCollapse">
                <button class="usf-label usf-btn" v-html="facet.title" :aria-label="usf.utils.format(loc.filterBy,facet.title)" :aria-expanded="!collapsed"></button>
                <usf-helptip v-if="facet.tooltip" :tooltip="facet.tooltip"></usf-helptip>            
                <!-- 'Clear all' button to clear the current facet filter. -->
                <button v-if="isInBreadcrumb" class="usf-clear-all usf-btn" :title="loc.clearFilterOptions" :aria-label="usf.utils.format(loc.clearFiltersBy,facet.title)" @click.prevent.stop="onClear" v-html="loc.clear"></button>
                <span class="usf-pm"></span>
            </div>
        </div>

        <!-- Filter body -->
        <div class="usf-container">
            <!-- Search box -->
            <input v-if="hasSearchBox" class="usf-search-box" :placeholder="loc.filterOptions" :value="term" @input="v => term = v.target.value">

            ` + _usfFilterBodyTemplate +
        `
        </div>
    </template>
</div>`
/*inc_end_filter*/,

    // facet filter option
    filterOption: /*inc_begin_filter-option*/
`<div v-if="children" :class="(isSelected ? 'usf-selected ' : '') + ' usf-relative usf-facet-value usf-facet-value-single usf-with-children' + (collapsed ? ' usf-collapsed' : '')">
    <!-- option label -->
    <button class="usf-pm usf-btn" aria-label="Toggle children" v-if="children" @click.prevent.stop="onToggleChildren"></button>
    <button class="usf-label usf-btn" v-html="label" @click.prevent.stop="onToggle"></button>

    <!-- product count -->
    <span v-if="!(!usf.settings.filterNavigation.showProductCount || (swatchImage && !usf.isMobileFilter)) && option.value !== undefined" class="usf-value">{{option.value}}</span>    

    <div class="usf-children-container" v-if="children && !collapsed">
        <button :class="'usf-child-item usf-btn usf-facet-value' + (isChildSelected(c) ? ' usf-selected' : '')" v-for="c in children" v-html="getChildLabel(c)" @click="onChildClick(c)"></button>
    </div>
</div>
<button v-else :class="(isSelected ? 'usf-selected ' : '') + (swatchImage ? ' usf-facet-value--with-background' : '') + ' usf-btn usf-relative usf-facet-value usf-facet-value-' + (facet.multiple ? 'multiple' : 'single')" :title="isSwatch || isBox ? label + ' (' + option.value + ')' : undefined" :style="usf.isMobileFilter ? null : swatchStyle" @click.prevent.stop="onToggle">
    <!-- checkbox -->
    <div v-if="!isBox && !isSwatch && facet.multiple" :class="'usf-checkbox' + (isSelected ? ' usf-checked' : '')">
        <span class="usf-checkbox-inner"></span>
    </div>

    <!-- swatch image in mobile -->
    <div v-if="swatchImage && usf.isMobileFilter" class="usf-mobile-swatch" :style="swatchStyle"></div>

    <!-- option label -->
    <span class="usf-label usf-btn" v-html="label"></span>
    
    <!-- product count -->
    <span v-if="!(!usf.settings.filterNavigation.showProductCount || (swatchImage && !usf.isMobileFilter)) && option.value !== undefined" class="usf-value">{{option.value}}</span>
</button>`
/*inc_end_filter-option*/,

    // Instant search popup
    instantSearch: /*inc_begin_instantsearch*/
`
<div :class="'usf-popup usf-zone usf-is usf-is--compact usf-is--' + position + (shouldShow ? '' : ' usf-hide') + (isEmpty ? ' usf-empty' : '') + (hasProductsOnly ? ' usf-is--products-only' : '') + (firstLoader ? ' usf-is--first-loader': '')"  :style="usf.isMobile ? null : {left: this.left + 'px',top: this.top + 'px',width: this.width + 'px'}">
    <!-- Mobile search box -->
    <div v-if="usf.isMobile">
        <form class="usf-is-inputbox" :action="searchUrl" method="get" role="search" @submit="onSubmitMobile">
            <span class="usf-icon usf-icon-back usf-close" @click="usf.utils.hideInstantSearch"></span>
            <input name="q" autocomplete="off" ref="searchInput" :value="term" @input="onSearchBoxInput">
            <span class="usf-remove" v-if="term" @click="onClear"></span>
        </form>
    </div>

    <!-- First loader -->
    <div class="usf-is-first-loader" v-if="firstLoader">
        <div class="usf-clear">
            <div class="usf-img"></div>
            <div class="usf-title"></div>
            <div class="usf-subtitle"></div>
        </div>
        <div class="usf-clear">
            <div class="usf-img"></div>
            <div class="usf-title"></div>
            <div class="usf-subtitle"></div>
        </div>
        <div class="usf-clear">
            <div class="usf-img"></div>
            <div class="usf-title"></div>
            <div class="usf-subtitle"></div>
        </div>
    </div>

    <!-- All JS files loaded -->
    <template v-else>
        <!-- Empty view -->
        <div v-if="isEmpty" class="usf-is-no-results">
            <div style="background:url('//cdn.shopify.com/s/files/1/0257/0108/9360/t/85/assets/no-items.png?t=2') center no-repeat;min-height:160px"></div>
            <div v-html="usf.utils.format(loc.noMatchesFoundFor, usf.utils.encodeHtml(term))"></div>
        </div>
        <template v-else>
            <!-- Body content -->
            <div class="usf-is-content"  :class="{'usf-is-content--without-sidebar': isEmptyExtraData, 'usf-is-content--without-results': !(queryOrTerm || (!queryOrTerm && settings.showPopularProducts))}">
                <!-- Products -->
                <div class="usf-is-matches usf-is-products"  v-if="(queryOrTerm || (!queryOrTerm && settings.showPopularProducts))">
                    <div class="usf-title" v-html="queryOrTerm ? loc.productMatches : loc.trending"></div>
                    
                    <div class="usf-is-list" v-if="result.items.length">
                        <!-- Did you mean -->
                        <span class="usf-is-did-you-mean" v-html="usf.utils.format(loc.didYouMean, usf.utils.encodeHtml(term), result.query)" v-if="termDiffers"></span>

                        <!-- Product -->
                        <usf-is-item v-for="p in result.items" :product="p" :result="result" :key="p.id + '-' + p.selectedVariantId"></usf-is-item>
                    </div>
                    <div class="usf-is-list" v-else style="background:url('//cdn.shopify.com/s/files/1/0257/0108/9360/t/85/assets/no-products.png?t=2') center no-repeat;min-height:250px"></div>
                </div>

                <div class="usf-is-side">
                    <template v-if="queryOrTerm">
                        <!-- Suggestions -->
                        <div class="usf-is-matches usf-is-suggestions" v-if="result.suggestions && result.suggestions.length">
                            <div class="usf-title" v-html="loc.searchSuggestions"></div>
                            <button v-for="s in result.suggestions" class="usf-is-match usf-btn" v-html="usf.utils.highlight(s, result.query)" @click="search(s)"></button>
                        </div>

                        <!-- Collections -->
                        <div class="usf-is-matches usf-is-collections" v-if="result.collections && result.collections.length">
                            <div class="usf-title" v-html="loc.collections"></div>
                            <button v-for="c in result.collections" class="usf-is-match usf-btn" v-html="usf.utils.highlight(c.title, result.query)" @click="selectCollection(c)"></button>
                        </div>

                        <!-- Pages -->
                        <div class="usf-is-matches usf-is-pages" v-if="result.pages && result.pages.length">
                            <div class="usf-title" v-html="loc.pages"></div>
                            <button v-for="p in result.pages" class="usf-is-match usf-btn" v-html="usf.utils.highlight(p.title, result.query)" @click="selectPage(p)"></button>
                        </div>
                    </template>

                        <!-- default screen -->
                        <template v-else>
                            <!-- Recently Search -->
                            <div class="usf-is-matches usf-is-suggestions usf-is-recently-search" v-if="hasRecentlySearches">
                                <div class="usf-title">
                                    <span v-html="loc.latestSearches"></span>
                                    <button class="usf-btn" v-html="loc.clear" @click.prevent.stop="clearAllRecentSearches"></button>
                                </div>
                                <div v-for="(s, index)  in recentlySearches" :key="s['title']" class="usf-is-match"   v-if="s && s['title']" @click="search(s['title'])">
                                    <div>
                                        <i class="usf-icon usf-icon-rollback">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 8l0 4l2 2"></path><path d="M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5"></path></svg>
                                        </i>
                                        <span v-html="s['title']"></span>
                                    </div>
                                    <button class="usf-icon usf-btn" @click.prevent.stop="()=>{removeRecentSearchAtIndex(index)}">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M18 6l-12 12"></path><path d="M6 6l12 12"></path></svg>
                                    </button>
                                </div>
                            </div>

                            <!-- Manual Suggestions -->
                            <div class="usf-is-matches usf-is-suggestions usf-is-suggestions--manual" v-if="hasManualSuggestion">
                                <div class="usf-title" v-html="loc.popularSearch"></div>
                                <div class="usf-is-match-list">
                                    <button v-for="(s, index) in manualSuggestions" :key="s" class="usf-btn usf-is-match"  @click="search(s)">
                                        <i class="usf-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M3 17l6 -6l4 4l8 -8"></path><path d="M14 7l7 0l0 7"></path></svg>
                                        </i>
                                        <span v-html="s"></span>
                                    </button>
                                </div>
                            </div>
                        </template>

                </div>
            </div>

            <!-- Footer -->
            <div class="usf-is-viewall" v-if="(queryOrTerm)">
                <button class="usf-btn" @click="search(queryOrTerm)" v-html="usf.utils.format(queryOrTerm ? loc.viewAllResultsFor : loc.viewAllResults, usf.utils.encodeHtml(queryOrTerm))"></button>
            </div>
        </template>
    </template>
</div>
`
/*inc_end_instantsearch*/
,

    // Instant search item
    instantSearchItem:/*inc_begin_instantsearch-item*/
`<div class="usf-is-product usf-clear" @click="onItemClick">
    <!-- Image -->
    <div class="usf-img-wrapper usf-pull-left">
        <img class="usf-img" :src="selectedImageUrl" :alt="selectedImage.alt">
    </div>
    
    <div class="usf-pull-left">
        <!-- Title -->
        <button class="usf-title usf-btn" v-html="usf.utils.highlight(product.title, result.query)"></button>

        <!-- Vendor -->
        <div class="usf-vendor" v-html="product.vendor" v-if="usf.settings.search.showVendor"></div>

        <!-- Prices -->
        <div class="usf-price-wrapper">
            <span class="usf-price" :class="{ 'usf-has-discount': hasDiscount }" v-html="displayPrice"></span>
            <span v-if="hasDiscount" class="usf-discount" v-html="displayDiscountedPrice"></span>
        </div>
    </div>
</div>`
/*inc_end_instantsearch-item*/,


};

usf.event.add('init', function () {    
    usf.platform.useProductsUrl = true;
	// register or override components
    // ...    
    /*var SearchResultsGridItem2 = {
        template: usf.templates.searchResultsGridViewItem,
    }
    usf.register(SearchResultsGridItem2, usf.components.SearchResultsGridItem, "usf-sr-griditem");*/
    _usfImageWidths = _usfIsDynamicImage ? [200, 400, 600, 700, 800, 900, 1000, 1200] : [usf.settings.search.imageSize];

    _usfSetDefaultThemeSettings();

    _usfImageSize = `(min-width: ${_usfGlobalSettings.max_page_width}px) ${_usfGlobalSettings.max_page_width/_usf_size_cols_desktop}px, (min-width: 768px) ${100/_usf_size_cols_desktop}vw, 50vw`

    if(_usfGlobalSettings.prod_thumb_shape == 'portrait-23'){
        window._usf_custom_aspect_ratio = 0.67
    }else if(_usfGlobalSettings.prod_thumb_shape == 'portrait-45'){
        window._usf_custom_aspect_ratio = 0.8
    }else if(_usfGlobalSettings.prod_thumb_shape == 'square'){
        window._usf_custom_aspect_ratio = 1
    }else if(_usfGlobalSettings.prod_thumb_shape == 'landscape-54'){
        window._usf_custom_aspect_ratio = 1.25
    }else if(_usfGlobalSettings.prod_thumb_shape == 'landscape-32'){
        window._usf_custom_aspect_ratio = 1.5
    }else if(_usfGlobalSettings.prod_thumb_shape == 'tallest'){
        window._usf_custom_aspect_ratio = 99;
        usf.event.add('sr_dataReceived', function(t, data){
            data.items.filter(item => {
                if(item.images.length){
                    var img = item.images[0];
                    if(item.selectedVariantId){
                        var selectedVariant = item.variants.find(v => v.id == item.selectedVariantId);
                        if(selectedVariant && item.images[selectedVariant.imageIndex]){
                            img = item.images[selectedVariant.imageIndex];
                        }
                    }
                    var imgRatio = _usfGetImageRatio(img);
                    if(imgRatio < _usf_custom_aspect_ratio){
                        _usf_custom_aspect_ratio = imgRatio;
                    }
                }
            })
        });
    }else{
        window._usf_custom_aspect_ratio = 0;
        usf.event.add('sr_dataReceived', function(t, data){
            data.items.filter(item => {
                if(item.images.length){
                    var img = item.images[0];
                    if(item.selectedVariantId){
                        var selectedVariant = item.variants.find(v => v.id == item.selectedVariantId);
                        if(selectedVariant && item.images[selectedVariant.imageIndex]){
                            img = item.images[selectedVariant.imageIndex];
                            
                        }
                    };
                    var imgRatio = _usfGetImageRatio(img);
                    if(imgRatio > _usf_custom_aspect_ratio){
                        _usf_custom_aspect_ratio = imgRatio;
                    }
                }
            })
        });
    }
 
    var NewSearchResultsGridItem = {
        mixins: [usf.components.SearchResultsGridItem],
        template: usf.templates.searchResultsGridViewItem,
        data(){
            var isNew;
            if(_usfGlobalSettings.prod_new_show){
                if(_usfGlobalSettings.prod_new_method == 'date'){
                    isNew = usfCheckNew(this.product.date)
                }else if(_usfGlobalSettings.prod_new_method == 'tag'){
                    isNew = this.product.tags.includes('Tag') || this.product.tags.includes('tag')
                }else if(usf.platform.collection){
                    var col_handle = usf.platform.collection.split('-');
                    isNew = col_handle.includes('new');
                }
            }
            return {
                metaLable: usf.utils.getMetafield(this.product,'theme','label'),
                subtitle: usf.utils.getMetafield(this.product,'descriptors','subtitle'),
                showNew: isNew,
            }
        },
        created(){
            this.product.images.filter(img => {
                img.id = usfRandomId();
            })
          
        },
        computed:{
            saleLabel(){
                var ll;
                if(_usfGlobalSettings.prod_reduction_show && this.hasDiscount && usf.settings.search.showSale){
                    if(_usfGlobalSettings.prod_reduction_type == 'percent'){
                        ll = _usfSalePercentHtml.replace('{{ amount }}',this.salePercent)
                    }else{
                        ll = _usfSaleHtml.replace('{{ amount }}',this.displayDiscount)
                    }   
                };
                return ll
            },
            labelCount(){
                var count = 0;
                if(this.metaLable != ''){
                    count++;
                };
                if(this.showNew){
                    count++;
                };
                if(this.saleLabel){
                    count++;
                };
                return count;
            }
        }
    }
    usf.register(NewSearchResultsGridItem, null, "usf-new-griditem");


    var UsfImage = {
        props: {
            image: Object,
            imageUrl: Object,
        },
        
        data(){
           
         
            var imageRatio = _usfGetImageRatio(this.image);
            var crop = 'region';
            var crop_left = 0;
            var crop_width = this.image.width
            var crop_height = crop_width / _usf_custom_aspect_ratio;
            var crop_top = (this.image.height - crop_height)*0.5;
            var addon = '';
        

            if(window._usf_custom_aspect_ratio && window._usf_custom_aspect_ratio != imageRatio && window._usf_custom_crop && window._usf_custom_crop != 'contain'){
                if(_usf_custom_aspect_ratio < imageRatio){
                    crop_top = 0;
                    crop_height = this.image.height;
                    crop_width = crop_height * _usf_custom_aspect_ratio;
                    crop_left =  (this.image.width - crop_width)* 0.5;
                };
            
                addon = `crop=${crop}&crop_height=${crop_height}&crop_left=${crop_left}&crop_top=${crop_top}&crop_width=${crop_width}&width=340`;
           
                if(this.imageUrl)
                    this.imageUrl = _usfAddQuery(this.imageUrl,addon);
                this.image.url = _usfAddQuery(this.image.url,addon);
            }
            return {
                imageRatio: imageRatio,
                srcset: _usfGetSrcset2(this.image),
                srcUrl: this.imageUrl ? this.imageUrl : _usfGetOriginImgWithSize(this.image.url,usf.settings.search.imageSize + 'x')
             
            }
        },  
        computed:{ 
            
        },
        render(h){
            if(_usf_custom_aspect_ratio && _usf_custom_crop == 'contain') {
                return h('div',{
                    class:'ar-contain',
                    style: '--aspect-ratio:' + _usf_custom_aspect_ratio + ';'
                },[
                    h('img',{
                        class:'theme-img',
                        attrs:{
                            srcset: this.srcset,
                            src: this.srcUrl,
                            sizes: _usfImageSize,
                            alt: this.image.alt,
                            loading: 'lazy',
                            width: this.image.width,
                            height: this.image.height
                        }
                    }) 
                ])
            }else{
                return h('img',{
                        class:'theme-img',
                        attrs:{
                            srcset: this.srcset,
                            src: this.srcUrl,
                            sizes: _usfImageSize,
                            alt: this.image.alt,
                            loading: 'lazy',
                            width: this.image.width,
                            height: this.image.height,
                        }
                    })
            }
        },
        
    }
    usf.register(UsfImage, null, "usf-img");



/**
 * color swatch component
 * */
var UsfSwatches = {
    props: {
        product: Object,
        option: Object,
        optionIndex:Number
    },
    data() {
        var isSwatchOpt = _usfGlobalSettings.swatch_option_name.includes(this.option.name);
        var optionWithValues = [];
        if(this.product.options.length > 1){
            var optionRendereds = {};
           
            this.option.values.filter(o => {
                for (let x = 0; x < this.product.variants.length; x++) {
                    var v = this.product.variants[x];
                    if (v.options[this.optionIndex] != undefined) {
                        var vrOpt = this.option.values[v.options[this.optionIndex]];
                        if (o === vrOpt && !optionRendereds[o]) {
                            optionRendereds[o] = 1;
                            optionWithValues.push({
                                value: o,
                                image: this.product.images[v.imageIndex],
                                variant: v,
                            });
                            break;
                        }
                    }
                };
            });
        }
        
      
       
       
        return {
            isSwatchOpt: isSwatchOpt,
            optionWithValues: optionWithValues
        }
    },
   
    methods: {
        _variantUrl(v) {
            return _usfAddQuery(this.$parent.productUrl, `variant=${v.id}`)
        }
    },
    render(h) {
        return h('div',{
            staticClass:'product-block-options',
        class:{
            'product-block-options--swatch': this.isSwatchOpt
        },
        attrs:{
            'data-option-name': this.option.name,
        }
        },[
            this.product.options.length == 1 ? h('div',{class:'product-block-options__inner'},[
                this.product.variants.map((v,index) => {
                    var image =  this.product.images[v.imageIndex];
                    var variantTitle =  _usfGetVariantTitle(v.options,this.product)
                    return h('span',{
                        staticClass:'product-block-options__item',
                        class:{
                            'product-block-options__item--unavailable': !_usfGlobalSettings.prod_thumb_options_disable_unavailable || usf.utils.isVariantSoldOut(v),
                            'product-block-options__item--truncated': index >= 3 && this.isSwatchOpt
                        },
                        attrs:{
                            'data-option-item': variantTitle,
                            'data-media': image ? image.id : false,
                            'data-swatch': this.isSwatchOpt && _usfGlobalSettings.swatch_method == 'swatches' ? variantTitle.replace('"','').toLowerCase() : false,
                        }
                    },[
                        h('span',{class:'product-block-options__item__text'},[variantTitle]),
                        _usfGlobalSettings.swatch_method == 'variant-images' && this.isSwatchOpt && image ? h('usf-img',{props:{ image: image}}) : false,
                    ])
                }),
                this.product.variants.length > 3 && this.isSwatchOpt ? h('span',{class:'product-block-options__more-label'},['+ ' + (this.product.variants.length - 3) + ' more']) : false
            ]) : h('div',{class:'product-block-options__inner'},[
                this.optionWithValues.map((o,index) => {
                    var show = true;
                    if(this.isSwatchOpt && _usfGlobalSettings.swatch_method == 'variant-images' && !o.image){
                        show = false;   
                    }
                    if(show){
                        var is_unavailable = false;
                        if(_usfGlobalSettings.prod_thumb_options_disable_unavailable){
                            is_unavailable = true;
                            for (let x = 0; x < this.product.variants.length; x++) {
                                var v = this.product.variants[x];
                                if (v.options[this.optionIndex] != undefined) {
                                    var vrOpt = this.option.values[v.options[this.optionIndex]];
                                    if (o.value === vrOpt && !usf.utils.isVariantSoldOut(v)) {
                                        is_unavailable = false;
                                        break;
                                    }
                                }
                            };
    
                        }
                       
                        return h('span',{
                            staticClass:'product-block-options__item',
                            class:{
                                'product-block-options__item--unavailable': is_unavailable,
                                'product-block-options__item--truncated': index >= 3 && this.isSwatchOpt
                            },
                            attrs:{
                                'data-option-item': o.value,
                                'data-media': o.image ? o.image.id : false,
                                'data-swatch': this.isSwatchOpt && _usfGlobalSettings.swatch_method == 'swatches' ? o.value.replace('"','').toLowerCase() : false,
                            }
                        },[
                            h('span',{class:'product-block-options__item__text'},[o.value]),
                            _usfGlobalSettings.swatch_method == 'variant-images' && this.isSwatchOpt && o.image ? h('usf-img',{props:{ image: o.image}}) : false,
                        ])
                    }
                    
                }),
                this.optionWithValues > 3 && this.isSwatchOpt ? h('span',{class:'product-block-options__more-label'},['+ ' + (this.optionWithValues.length - 3) + ' more']) : false

            ])
        ])
    }
}
usf.register(UsfSwatches, null, 'usf-swatches');



       
      /**
    * custom filter
    * */
      var SymmetryFilter = {
        mounted() {
            this.$nextTick(function () {
                if (!usf.settings.filters.horz && !usf.isMobile) {
                    
                    this.moveFilter();
                    usf.event.add('mobile_changed', this.moveFilter);
                }
            })
        },
        methods:{
            moveFilter(){
                var el = this.$el;
                    var drawerZone = document.getElementById('usf_filters')
                    if (drawerZone) {
                        drawerZone.insertBefore(el, drawerZone.firstChild);
                        document.body.classList.add('usf-has-filter-drawer');
                    }
            }
        },
        render(h) {
            return h('usf-filters');
        }
    }
    usf.register(SymmetryFilter, null, 'symmetry-filter');
  
    

});
function usfRandomId() {
    var S4 = function() {
       return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    };
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}
function _usfGetSrcset2(img) {
    var srcset = [];
    var _usfImageWidths = window._usfImageWidths ? window._usfImageWidths : _usfIsDynamicImage ? [200, 400, 600, 700, 800, 900, 1000, 1200] : [usf.settings.search.imageSize]
    _usfImageWidths.filter(w => {
        if(img.width >= w){
            srcset.push(_usfGetOriginImgWithSize(img.url, usf.settings.search.imageSize + 'x') + ` ${w}w`);
        }
    });
    return srcset.length ? srcset.join(',') : _usfGetOriginImgWithSize(img.url, usf.settings.search.imageSize + 'x') + ' ' + usf.settings.search.imageSize + 'w';
}
function _usfGetVariantTitle(options, p) {
    if(!p.options.length)
        return 'Default title'
    var arrs = [];
    for (let i = 0; i < options.length; i++) {
        var o = options[i];
        arrs.push(p.options[i].values[o])
    }
    return arrs.join(' / ');
}
function _usfSetDefaultThemeSettings(){
    
  window._usfGlobalSettings = window._usfGlobalSettings  || {
    prod_thumb_hover_image: true,
    prod_thumb_text_align: "center",
    quickbuy_style: "whole",
    prod_new_show: true,
    prod_new_method: "date",
    prod_new_limit_int: 7,
    prod_reduction_show: true,
    prod_reduction_type: "percent",
    prod_stock_warn_show: true,
    prod_stock_warn_limit_int: 5,
    quickbuy_color_scheme: "1",
    prod_thumb_show_subtitle: true,
    prod_sold_out_show: true,
    prod_pre_order_label_show: false,
    prod_sale_show: true,
    max_page_width: 1480,
    swatch_enabled: true,
    prod_thumb_show_options: true,
    prod_thumb_shape: "square",
  };
  window._usfShowVendor = window._usfShowVendor || false;
 
  window._usfGridWrapClass = window._usfGridWrapClass || "product-grid product-grid--per-row-3 product-grid--per-row-mob-2 product-grid--per-row-mob-2";
  window._usf_custom_crop = window._usf_custom_crop || "center";
  window._usf_options_to_show = window._usf_options_to_show || ["Color"];
  window._usf_size_cols_desktop =  window._usf_size_cols_desktop || 3;
  
  if(!window._usfPrevTxt || window._usfPrevTxt.includes('missing')){
      window._usfPrevTxt = "Previous";
  }
  if(!window._usfNextTxt || window._usfNextTxt.includes('missing')){
      window._usfNextTxt = "Next";
  }
    if(!window._usfNewTxt || window._usfNewTxt.includes('missing')){
      window._usfNewTxt = "New arrival";
  }
    if(!window._usfSalePercentHtml || window._usfSalePercentHtml.includes('missing')){
      window._usfSalePercentHtml = "{{ amount }}% off";
  }
  if(!window._usfSaleHtml || window._usfSaleHtml.includes('missing')){
      window._usfSaleHtml = "{{ amount }} off";
  }
  if(!window._usfSaleHtml || window._usfSaleHtml.includes('missing')){
      window._usfSaleHtml = "{{ quantity }} in stock";
  }

  window._usfNoImageSvg = window._usfNoImageSvg ||"\u003csvg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" viewBox=\"0 0 525.5 525.5\"\u003e\u003cpath d=\"M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z\"\/\u003e\u003cpath d=\"M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z\"\/\u003e\u003cpath d=\"M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z\"\/\u003e\u003cpath d=\"M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z\"\/\u003e\u003c\/svg\u003e";
  
}
var usfCheckNew = function (day) {
    var dayNow = new Date(Date.now());
    var productDate = new Date(day);
    var distance = dayNow - productDate;
    var diffDays = Math.floor(distance / (1000 * 60 * 60 * 24));

    return diffDays < _usfGlobalSettings.prod_new_limit_int
}

function _usfOnAddToCartSuccess(rs, formSelector) {
}
 

/* Begin theme ready code */
if (usf.settings.instantSearch.online) {
    document.body.classList.add('usf-hide-theme-search');
    if (usf.isMobile) {
        var searchIcon = document.querySelector(usf.isMobile ? '#pageheader a.show-search-link' : '.logo-area__right a.show-search-link');
        if (searchIcon)
            searchIcon.addEventListener('click', function () {
                var target = document.querySelector('.main-search__form input[name="q"]') || document.createElement('input');
                usf.utils.loadAndShowInstantSearch(target, true);
            });

        // still register to 'is_show' event to hide the drawer.
        usf.event.add('is_show', function () {
            setTimeout(() => {
                var btn = document.querySelector('main-search .main-search__close');
                if (btn && document.body.classList.contains('show-search'))
                    btn.click();
                // refocus on our input box
                usf.instantSearch.focus();
            }, 300);
        });
    }
}
/* End theme ready code */  